import { render, staticRenderFns } from "./CreateCandle.vue?vue&type=template&id=1d247c21&scoped=true&lang=pug&"
import script from "./CreateCandle.vue?vue&type=script&lang=ts&"
export * from "./CreateCandle.vue?vue&type=script&lang=ts&"
import style0 from "./CreateCandle.vue?vue&type=style&index=0&id=1d247c21&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d247c21",
  null
  
)

export default component.exports